import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const h = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const fmt = n => Number(n || 0).toLocaleString('uz-UZ');

function UserDetail({ userId, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/super/users/${userId}`, h()).then(r => setData(r.data)).catch(() => {});
  }, [userId]);

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{
        background: 'var(--bg)', borderRadius: 16, padding: 28, width: 520, maxHeight: '80vh', overflowY: 'auto',
        border: '1px solid var(--border)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 16, fontWeight: 800 }}>{data?.user?.name || '...'}</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>
        {data ? (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
              {[
                ['Telefon', data.user.phone],
                ['Sessiyalar', data.user.sessions_count],
                ['Jami to\'lov', fmt(data.user.total_spent) + ' so\'m'],
                ['Oxirgi sessiya', data.user.last_session ? new Date(data.user.last_session).toLocaleDateString('uz-UZ') : '—'],
              ].map(([k, v]) => (
                <div key={k} style={{ background: 'var(--bg2)', borderRadius: 10, padding: '12px 16px' }}>
                  <div style={{ fontSize: 11, color: 'var(--text3)' }}>{k}</div>
                  <div style={{ fontWeight: 700, marginTop: 4 }}>{v}</div>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>So'nggi sessiyalar</div>
            {data.sessions?.map(s => (
              <div key={s.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: 13 }}>{s.lab_name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)' }}>{new Date(s.started_at).toLocaleDateString('uz-UZ')}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 700, color: '#f59e0b' }}>{fmt(s.amount)} so'm</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)' }}>{s.duration_minutes} daq</div>
                </div>
              </div>
            ))}
          </>
        ) : <div style={{ textAlign: 'center', color: 'var(--text3)', padding: 40 }}>Yuklanmoqda...</div>}
      </div>
    </div>
  );
}

export default function SuperUsers() {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const limit = 30;

  const load = useCallback(() => {
    setLoading(true);
    axios.get(`${API}/super/users`, { ...h(), params: { page, limit, search } })
      .then(r => { setUsers(r.data.users); setTotal(r.data.total); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  const pages = Math.ceil(total / limit);

  return (
    <div style={{ maxWidth: 1000 }}>
      {selectedId && <UserDetail userId={selectedId} onClose={() => setSelectedId(null)} />}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, color: '#f59e0b' }}>👥 Foydalanuvchilar</div>
          <div style={{ fontSize: 12, color: 'var(--text3)' }}>Jami: {total} ta</div>
        </div>
      </div>

      <input
        value={search} onChange={e => { setSearch(e.target.value); setPage(1); }}
        placeholder="Ism yoki telefon qidirish..."
        style={{
          width: '100%', padding: '10px 14px', background: 'var(--bg2)',
          border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text)',
          fontSize: 13, marginBottom: 20, boxSizing: 'border-box',
        }}
      />

      <div style={{ background: 'var(--bg2)', borderRadius: 14, border: '1px solid var(--border)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['Ism', 'Telefon', 'Sessiyalar', 'Jami to\'lov', 'Oxirgi sessiya'].map(col => (
                <th key={col} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase' }}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Yuklanmoqda...</td></tr>
            ) : users.map(u => (
              <tr key={u.id} onClick={() => setSelectedId(u.id)} style={{
                borderBottom: '1px solid var(--border)', cursor: 'pointer',
              }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(245,158,11,0.04)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={{ padding: '12px 16px', fontWeight: 700 }}>{u.name}</td>
                <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text2)' }}>{u.phone}</td>
                <td style={{ padding: '12px 16px', fontWeight: 700 }}>{u.sessions_count}</td>
                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#f59e0b' }}>{fmt(u.total_spent)} so'm</td>
                <td style={{ padding: '12px 16px', fontSize: 12, color: 'var(--text3)' }}>
                  {u.last_session ? new Date(u.last_session).toLocaleDateString('uz-UZ') : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {pages > 1 && (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 20 }}>
          {Array.from({ length: Math.min(pages, 10) }, (_, i) => i + 1).map(p => (
            <button key={p} onClick={() => setPage(p)} style={{
              width: 36, height: 36, borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13,
              background: p === page ? 'rgba(245,158,11,0.2)' : 'var(--bg2)',
              border: `1px solid ${p === page ? '#f59e0b' : 'var(--border)'}`,
              color: p === page ? '#f59e0b' : 'var(--text2)',
            }}>{p}</button>
          ))}
        </div>
      )}
    </div>
  );
}
